// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1FlRr","list":"BalanceDue_list__2HfIv","listRow":"BalanceDue_listRow__3erlo","total":"BalanceDue_total__3VS5d"};